import { IdentityParameter } from "@/features/types";
import useFetcher from "@/utils/use-fetcher";
import {
  calcIdentityUrlPrefix,
  SWRObjectKey,
} from "@/features/ui/helpers/fetcher-helpers";
import useSWR, { SWRConfiguration } from "swr";
import { OrderSheetTab } from "@/features/order-sheets/order-sheet.type";

export interface GetOrderSheetTabV2Request {}
export interface GetOrderSheetTabV2Response extends OrderSheetTab {}

export interface GetOrderSheetTabV2PathParameter extends IdentityParameter {
  orderSheetSetId: number;
}

export function getGetOrderSheetTabV2Key(
  parameter: GetOrderSheetTabV2PathParameter,
  request?: GetOrderSheetTabV2Request
): SWRObjectKey<GetOrderSheetTabV2Request> {
  const { orderSheetSetId } = parameter;
  let url = calcIdentityUrlPrefix(parameter);
  url += `/order-sheet-sets/${orderSheetSetId}/tabs`;
  return {
    url,
    params: request,
  };
}
export default function useGetOrderSheetTabV2(
  parameter: GetOrderSheetTabV2PathParameter,
  request: GetOrderSheetTabV2Request,
  config: SWRConfiguration
) {
  const fetcher = useFetcher<
    GetOrderSheetTabV2Request,
    GetOrderSheetTabV2Response
  >();

  return useSWR(getGetOrderSheetTabV2Key(parameter, request), fetcher, config);
}
